import { isNode } from 'detect-node-es';
export var env = {
    isNode: isNode,
    forceCache: false,
};



//////////////////
// WEBPACK FOOTER
// ./~/use-sidecar/dist/es2015/env.js
// module id = 9165
// module chunks = 2